export const ADVANCED_TABS_GROUP_PROP = {
  STYLE: "style",
  ALIGNMENT: "alignment",
  WIDTH: "width",
  ACTIVE: "active",
  INACTIVE: "inactive",
  HOVER: "hover",
  ICON_PREVIEW: "iconPreview",
  COLORS: "colors",
};

export const DEFAULT_TABS = [
  { label: "Tab 1", value: "tab-1" },
  { label: "Tab 2", value: "tab-2" },
  { label: "Tab 3", value: "tab-3" },
];
